import { Switch } from 'antd';
import React from 'react';
import { Param } from '../../cliDataSchema';
import ParamFormItem from './ParamFormItem';

type Props = {
  param: Param;
  visibleParams: Param[];
};

const BooleanOption: React.FC<Props> = ({ param, visibleParams }) => {
  const [disabled, setDisabled] = React.useState(false);
  return (
    <ParamFormItem
      param={param}
      disabled={disabled}
      setDisabled={setDisabled}
      visibleParams={visibleParams}
    >
      <Switch disabled={disabled} />
    </ParamFormItem>
  );
};

export default BooleanOption;
